import React, { useState } from "react";
import classNames from "classnames";
import { SectionSplitProps } from "../../utils/SectionProps";
import { Link } from "react-router-dom";
import Expand from "react-expand-animated";

import canoeLogo from "../../assets/images/canoe-logo-banner.svg";
import UofT from "../../assets/images/toronto.svg";
import apparatus from "../../assets/images/data-collection-apparatus.jpg";

import Map from "../elements/Map";
import LazyMount from "../elements/LazyMount";

import SensorSuite from "../elements/SensorSuite";

import "../../assets/customStyles/styles.css";

const propTypes = {
  ...SectionSplitProps.types,
};

const defaultProps = {
  ...SectionSplitProps.defaults,
};

const FeaturesSplit = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertMobile,
  invertDesktop,
  invertColor,
  alignTop,
  imageFill,
  ...props
}) => {
  const outerClasses = classNames(
    "features-split section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    invertMobile && "invert-mobile",
    invertDesktop && "invert-desktop",

    className
  );

  const splitClasses = classNames("split-wrap", alignTop && "align-top");

  const [hopen, sethOpen] = useState([false]);
  const transitions = ["height", "opacity", "background"];

  return (
    <section {...props} className={outerClasses}>
      <div className="container">
        <div className={splitClasses}>
          <div
            className="split-item"
            style={{ width: "100%", display: "flex" }}
          >
            <div
              className="split-item-content center-content-mobile reveal-from-right"
              data-reveal-container=".split-item"
              style={{ display: "inline-flex", justifyContent: "center" }}
            >
              <div
                className="mt-16 mb-16 reveal-from-bottom"
                data-reveal-delay="200"
              >
                <img
                  src={canoeLogo}
                  style={{ width: "25em", marginTop: 0, marginBottom: 0 }}

                  alt=""
                />
              </div>
            </div>
            <div
              className="split-item-content center-content-mobile reveal-from-left"
              data-reveal-container=".split-item"
              style={{ display: "inline-flex", justifyContent: "center" }}
            >
              <div
                className="mb-16 mt-32 reveal-from-bottom center"
                data-reveal-delay="400"
              >
                <img
                  src={UofT}
                  style={{ width: "24em", marginBottom: 10 }}
                  alt=""
                />
              </div>
            </div>
          </div>
          <h2
            className="m-0 mb-32 reveal-from-bottom center-content"
            data-reveal-delay="400"
          >
            Canadian Aquatic Navigation for Observation of the Environment (CANOE)&nbsp;Dataset
          </h2>
          <div
            className="reveal-from-bottom center center-content"
            data-reveal-delay="600"
          >
            <Link
              to="/download"
              className="button button-primary button-wide-mobile button-sm"
              style={{
                zIndex: 10,
                width: 250,
                height: 80,
                alignItems: "center",
                fontSize: 26,
              }}
            >
              Download
            </Link>
          </div>
          <div
            className="reveal-from-bottom center center-content mt-32"
            data-reveal-delay="600"
          >
            <p>
              The CANOE dataset is an aquatic navigation dataset featuring a rich sensor suite with a 
              360&deg; radar, 
              360&deg; lidar with integrated IMU,
              stereo camera, 
              sonar,
              sidescan,
              motor power inputs, 
              and post-processed GPS data for ground truth poses.
              It includes over 14 hours and 20 km of data collected on a lake and reservoir in Ontario, Canada.
              The dataset supports the development of odometry and localization algorithms for marine robotics.
            </p>
          </div>
          <div className="split-item">
            <div
              className="split-item-content center-content-mobile reveal-from-right"
              data-reveal-container=".split-item"
              style={{ width: "578px", alignSelf: "center" }}
            >
              <img
                src={apparatus}
                alt="CANOE data collection apparatus"
                style={{ width: "100%", height: "400px", objectFit: "cover", borderRadius: 8 }}
              />
            </div>
            <div
              className="split-item-content center-content-mobile reveal-from-left"
              data-reveal-container=".split-item"
              style={{ width: "578px", alignSelf: "center" }}
            >
              <LazyMount
                style={{ width: "100%", height: "400px" }}
                placeholder={
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: 8,
                      background: "#f0f0f0",
                    }}
                  />
                }
              >
                <iframe
                  src={process.env.PUBLIC_URL + "/otter-tf-viewer-modified.html"}
                  style={{ width: "100%", height: "100%", border: "none", borderRadius: 8 }}
                  title="CANOE data collection vessel"
                />
              </LazyMount>
            </div>
          </div>

          <div className="reveal-from-bottom mt-32" data-reveal-delay="200">
            <LazyMount
              style={{ width: "100%", height: 400 }}
              placeholder={<div style={{ width: "100%", height: "100%", background: "#f0f0f0" }} />}
            >
              <Map />
            </LazyMount>
          </div>

          <p style={{ fontSize: 12 }}>
            This work is licensed under a{" "}
            <a href={"https://creativecommons.org/licenses/by/4.0/"}>
              Creative Commons Attribution 4.0 International Public License (“CC
              BY 4.0”)
            </a>{" "}
            .
          </p>
        </div>
      </div>
    </section>
  );
};

FeaturesSplit.propTypes = propTypes;
FeaturesSplit.defaultProps = defaultProps;

export default FeaturesSplit;
